export const quickReplies: string[] = [
  "Apply at iCXeed.",
  "Our Values.",
  "Our DNA.",
];
